class AccountService {
    constructor($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    }

    getOrderState(documentNumber, orderNumber) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES +
                '?terceroId=' + documentNumber +
                '&pedidoId=' + orderNumber,
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    getUserInfo(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.getUserInfo,
                data: this.$httpParamSerializerJQLike(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    passwordUpdate(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.passwordUpdate,
                data: this.$httpParamSerializerJQLike(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    userUpdate(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.userUpdate,
                data: this.$httpParamSerializerJQLike(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    getGenero() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getGenero,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

}

AccountService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default AccountService;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/account/account.service.js
 **/